<script>
	import { Button, Col, Row } from "sveltestrap";
	import { form, field } from "svelte-forms";
	import { required } from "svelte-forms/validators";
	import ErrorMessageHandler from "../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import Loader from "../../components/Loader/Loader.svelte";
	import PageHeader from "../../components/PageHeader/PageHeader.svelte";
	import client from "../../services/client";
	import { navigate } from "svelte-routing";
	import {
		loading,
		masterData,
		errorMessage,
		editFuelcardData,
	} from "../../store/store";
	import { extractErrorMessage } from "../../utils/misc";
	import CustomInput from "../../components/CustomInput/CustomInput.svelte";
	import CustomSelect from "../../components/CustomSelect/CustomSelect.svelte";

	export let fuelCardId;

	const card_no = field(
		"card_no",
		`${fuelCardId ? $editFuelcardData?.cardNo : ""}`,
		[required()]
	);
	const fuel_company_id = field(
		"fuel_company_id",
		fuelCardId ? $editFuelcardData?.fuelCompanyId : "",
		[required()]
	);
	const car_plate_number = field(
		"car_plate_number",
		`${fuelCardId ? $editFuelcardData?.plateNumber : ""}`,
		[required()]
	);
	const pin = field("pin", `${fuelCardId ? $editFuelcardData?.pin : ""}`);
	const myForm = form(card_no, fuel_company_id, car_plate_number, pin);

	let duplicateCardNo;
	let duplicatePlateNo;
	let load = false;
	$: updatedStatus = "";

	loading.subscribe((value) => {
		load = value;
	});

	async function handleSubmit() {
		loading.set(true);
		try {
			const res = await client("/v1/fuel/cards", {
				method: `${fuelCardId ? "PUT" : "POST"}`,
				version: "Vehicle",
				data: {
					cardNo: $card_no.value,
					fuelCompanyId: +$fuel_company_id.value,
					carPlateNumber: $car_plate_number.value,
					id: +fuelCardId,
				},
			});

			loading.set(false);
			if (res.status == 200) {
				navigate("/fuel-card-management");
			}
		} catch (error) {
			loading.set(false);
			extractErrorMessage(error);
		}
	}
</script>

<Row>
	<Col>
		<div>
			<ErrorMessageHandler message={updatedStatus || $errorMessage} />
			<PageHeader
				title={(fuelCardId ? `Edit` : "Create") + " Fuel Card"}
			/>
			<Col>
				<Row>
					<Col>
						<label for="card_no" class="d-block">
							<span> <b>Card Number.*</b> </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={5}>
						<CustomInput
							type="text"
							bind:value={$card_no.value}
							error={$myForm.hasError("card_no.required") ||
								duplicateCardNo}
							errorText={$myForm.hasError("card_no.required")
								? "Card number is required"
								: duplicateCardNo
								? "This card number is already added"
								: ""}
						/>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="fuel_company_id" class="d-block mt-3">
							<span> <b>Fuel Company*</b> </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={5}>
						<CustomSelect
							type="text"
							options={$masterData.fuelCompanies}
							bind:value={$fuel_company_id.value}
							error={$myForm.hasError("fuel_company_id.required")}
							errorText="Fuel company is required"
							defaultOption="Select Fuel Company"
						/>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="car_plate_number" class="d-block mt-3">
							<span> <b>Car Plate Number*</b> </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={5}>
						<CustomInput
							type="text"
							bind:value={$car_plate_number.value}
							error={$myForm.hasError(
								"car_plate_number.required"
							) || duplicatePlateNo}
							errorText={$myForm.hasError(
								"car_plate_number.required"
							)
								? "Car plate number is required"
								: duplicatePlateNo
								? "This plate number is already added"
								: ""}
						/>
					</Col>
				</Row>
			</Col>

			<Col>
				<Row>
					<Col>
						<label for="pin" class="d-block mt-3">
							<span> <b>Pin Number</b> </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={5}>
						<CustomInput
							type="text"
							bind:value={$pin.value}
							disabled={true}
						/>
					</Col>
				</Row>
			</Col>
			<Row>
				<Col class="d-flex justify-content-end gap-3">
					<Button class="themeButton" on:click={myForm.reset}>
						Reset
					</Button>
					<span
						class="d-inline-block"
						data-bs-toggle={!$myForm.valid ? "tooltip" : ""}
						title={!$myForm.valid ? "Fill all required field" : ""}
					>
						<Button
							class="themeButton primary"
							disabled={!$myForm.valid ||
								!$car_plate_number.value ||
								!$fuel_company_id.value ||
								!$card_no.value}
							on:click={() => handleSubmit()}
							on:click={myForm.validate}
						>
							{#if load}
								<Loader />
							{:else}
								{fuelCardId ? "Update" : "Create"}
							{/if}
						</Button>
					</span>
				</Col>
			</Row>
		</div>
	</Col>
</Row>
